import InfoCardComponent from './InfoCardComponent';
export * from './InfoCardComponent';
export default InfoCardComponent;
